import useMarket from 'stores/useMarket';
import { User } from '../generated/graphql';
import PinkPlaceholderProfileImage from '../../public/profile-photo-placeholder-pink.svg';
import GreyPlaceholderProfileImage from '../../public/profile-photo-placeholder-grey.svg';

type ProfilePhotoHookOptions = {
    profilePhoto?: string | null;
    user?: User;
    color?: 'pink' | 'grey';
};

export function useProfilePhoto(options: ProfilePhotoHookOptions) {
    const backendDomain = useMarket((state) => state.backendDomain);
    const image = options.user?.profile_photo_path || options.profilePhoto;

    const fallbackSrc = options.color === 'grey'
        ? GreyPlaceholderProfileImage.src
        : PinkPlaceholderProfileImage.src;

    const profilePhotoSrc = image
        ? `${backendDomain}/api/file/profilePhoto/${image}`
        : undefined;

    return {
        fallbackSrc,
        profilePhotoSrc,
    };
}
